import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form form-additional"
}
const _hoisted_2 = { class: "value element js-animation" }
const _hoisted_3 = { class: "item_value" }
const _hoisted_4 = { class: "value element js-animation" }
const _hoisted_5 = { class: "item_value" }
const _hoisted_6 = { class: "value element js-animation" }
const _hoisted_7 = { class: "item_value" }
const _hoisted_8 = { class: "value element js-animation" }
const _hoisted_9 = { class: "item_value" }
const _hoisted_10 = { class: "value element js-animation" }
const _hoisted_11 = { class: "item_value" }
const _hoisted_12 = { class: "value element js-animation" }
const _hoisted_13 = { class: "item_value" }
const _hoisted_14 = { class: "value element js-animation" }
const _hoisted_15 = { class: "item_value" }
const _hoisted_16 = { class: "value element js-animation" }
const _hoisted_17 = { class: "item_value" }
const _hoisted_18 = { class: "value element js-animation" }
const _hoisted_19 = { class: "item_value" }
const _hoisted_20 = { class: "value element js-animation" }
const _hoisted_21 = { class: "item_value" }
const _hoisted_22 = { class: "value element js-animation" }
const _hoisted_23 = { class: "item_value" }
const _hoisted_24 = { class: "value element js-animation" }
const _hoisted_25 = { class: "item_value" }
const _hoisted_26 = { class: "value element js-animation" }
const _hoisted_27 = { class: "item_value" }
const _hoisted_28 = { class: "value element js-animation" }
const _hoisted_29 = { class: "item_value" }
const _hoisted_30 = { class: "value element js-animation" }
const _hoisted_31 = { class: "item_value" }
const _hoisted_32 = { class: "value element js-animation" }
const _hoisted_33 = { class: "item_value" }
const _hoisted_34 = { class: "value element js-animation" }
const _hoisted_35 = { class: "item_value" }
const _hoisted_36 = { class: "value element js-animation" }
const _hoisted_37 = { class: "item_value" }
const _hoisted_38 = { class: "value element js-animation" }
const _hoisted_39 = { class: "item_value" }
const _hoisted_40 = { class: "value element js-animation" }
const _hoisted_41 = { class: "item_value" }
const _hoisted_42 = { class: "value element js-animation" }
const _hoisted_43 = { class: "item_value" }

import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import MainTemplate from '@/components/MainTemplate.vue'
import { useStore } from 'vuex'
import router from '@/router'
import { DECREASE_LOADING_COUNT_STATE, INCREASE_LOADING_COUNT_STATE } from '@/constant/store/MutationTypes'


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewSubmission',
  props: { visible: Boolean },
  emits: ['submit', 'back'],
  setup(__props, { emit: __emit }) {

const props = __props
const route = useRoute()
const store = useStore()

const data = ref('')

const formatDate = (date: any) => {
  if (date == null || date === '') {
    return ''
  }

  // check for invalid date
  if (isNaN(date.getTime())) {
    return ''
  }
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
  const month = date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
  return date.getFullYear() + '/' + month + '/' + day
}

const sendToSever = (data: any) => {
  store.commit(`fnol/${INCREASE_LOADING_COUNT_STATE}`)
  store.dispatch('fnol/submit', data)
    .then(response => {
      const responseData = response.data.data
      if (responseData.receivedNumber) {
        router.push('/receipt/' + responseData.receivedNumber)
      } else {
        router.push({ path: '/data-submission-error', query: { data: JSON.stringify(data) } })
      }
      store.commit(`fnol/${DECREASE_LOADING_COUNT_STATE}`)
    }).catch((error: any) => handleError(error, data))
}

const handleError = (error: any, data: any) => {
  store.commit(`fnol/${DECREASE_LOADING_COUNT_STATE}`)
  const dataStr = JSON.stringify(data)

  const errorMsg = error.response?.data.errorMessage

  if (errorMsg) {
    router.push({ path: '/network-submission-error', query: { data: dataStr } })
  }
}

const handleSubmission = () => {
  sendToSever(data.value)
}

const updateData = (updateData: any) => {
  data.value = updateData
}

const handleBack = () => {
  const jsonData = JSON.stringify(data.value)
  router.push({ path: '/fnol-form', query: { data: jsonData } })
}

onMounted(() => {
  if (!route.query.data) {
    return
  }
  const rawData = JSON.parse(route.query.data || '{}')
  rawData.c2AccidentDate = new Date(rawData.c2AccidentDate)
  rawData.c2DriverDob = rawData.c2DriverDob !== null ? new Date(rawData.c2DriverDob) : null
  updateData(rawData)
})

const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MainTemplate, null, {
    default: _withCtx(() => [
      (props.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[42] || (_cache[42] = _createElementVNode("div", { class: "title" }, "登録情報確認", -1)),
            _createElementVNode("div", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "item_key" }, "証券番号", -1)),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_3, _toDisplayString(data.value.policyNumber), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "item_key" }, "ご連絡者様のお名前", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_5, _toDisplayString(data.value.c1FullName), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "item_key" }, "ご連絡者様のお電話番号", -1)),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_7, _toDisplayString(data.value.c1Tel), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "item_key" }, "ご契約者様との関係", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t(data.value?.c1InsuRlRelation?.description || '')), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "item_key" }, "ご契約者様のお名前(カナ)", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_11, _toDisplayString(data.value.c1ContractNameKana), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "item_key" }, "ご契約者様のお名前", -1)),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_13, _toDisplayString(data.value.c1ContractFullName), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "item_key" }, "ご契約者様のお電話番号", -1)),
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_15, _toDisplayString(data.value.c1HomeTel), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "item_key" }, "契約車両の登録番号", -1)),
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_17, _toDisplayString(data.value.c1RegistraNum), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "item_key" }, "事故発生年月日", -1)),
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_19, _toDisplayString(formatDate(data.value.c2AccidentDate)), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "item_key" }, "事故発生時刻", -1)),
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_21, _toDisplayString(data.value.c2AccidentTime), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "item_key" }, "事故場所", -1)),
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_23, _toDisplayString(data.value.c2JikoPlace), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "item_key" }, "運転されていた方のお名前(カナ)", -1)),
              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_25, _toDisplayString(data.value.c2DriverNameKara), 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "item_key" }, "運転されていた方のお名前", -1)),
              _cache[25] || (_cache[25] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_27, _toDisplayString(data.value.c2DriverFullName), 1)
            ]),
            _createElementVNode("div", _hoisted_28, [
              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "item_key" }, "性別", -1)),
              _cache[27] || (_cache[27] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t(data.value?.c2Sex?.description || '')), 1)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "item_key" }, "生年月日", -1)),
              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_31, _toDisplayString(formatDate(data.value.c2DriverDob)), 1)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _cache[30] || (_cache[30] = _createElementVNode("div", { class: "item_key" }, "年齢", -1)),
              _cache[31] || (_cache[31] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_33, _toDisplayString(data.value.c2DriverAge), 1)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _cache[32] || (_cache[32] = _createElementVNode("div", { class: "item_key" }, "TEL", -1)),
              _cache[33] || (_cache[33] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_35, _toDisplayString(data.value.c2DriverTel), 1)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _cache[34] || (_cache[34] = _createElementVNode("div", { class: "item_key" }, "ご契約者様との関係", -1)),
              _cache[35] || (_cache[35] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t(data.value?.c2InsuRlRelation?.description || '')), 1)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _cache[36] || (_cache[36] = _createElementVNode("div", { class: "item_key" }, "登録番号", -1)),
              _cache[37] || (_cache[37] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_39, _toDisplayString(data.value.c2RegistraNum), 1)
            ]),
            _createElementVNode("div", _hoisted_40, [
              _cache[38] || (_cache[38] = _createElementVNode("div", { class: "item_key" }, "事故状況", -1)),
              _cache[39] || (_cache[39] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_41, _toDisplayString(data.value.c2AccidentConditionText), 1)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _cache[40] || (_cache[40] = _createElementVNode("div", { class: "item_key" }, "その他連絡事項", -1)),
              _cache[41] || (_cache[41] = _createElementVNode("div", { class: "space" }, null, -1)),
              _createElementVNode("div", _hoisted_43, _toDisplayString(data.value.c2SpecialItem), 1)
            ]),
            _createElementVNode("div", { class: "btn_box" }, [
              _createElementVNode("button", {
                type: "button",
                onClick: handleBack,
                class: "btn btn-outline-secondary btn-back",
                "data-href": "/Web/Contract/Back"
              }, "戻る"),
              _createElementVNode("input", {
                type: "submit",
                onClick: handleSubmission,
                value: "送信",
                class: "btn btn-success"
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})